/* eslint-disable no-undef */
import $ from "jquery";

const changePrice = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-change-price",
            buttonEdit: "#button-edit",
            parentClass: ".js-parent-button-change-price",
            inputPrice: "#input-price",
            inputPriceText: "#input-price-text",
            productId: "#js-productId",
        };

        // if ($(el.parentClass).length === 0) return;

        $(document).on("click", el.button, function (e) {
            e.preventDefault();
            const price =
                $(el.inputPrice).val() === "" ? "0" : $(el.inputPrice).val();
            const currency = $(el.inputPriceText).data("currency");
            const priceFormatted = price
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            // console.log($(el.inputPriceText).data("price"));
            $(el.inputPriceText).html(
                `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">${currency}</span>&nbsp;${priceFormatted}</bdi></span>`,
            );
            $(el.parentClass).toggleClass("edit");

            const data = {
                action: themeObj.customer.action.change_price,
                nonce: themeObj.customer.nonce,
                product_id: $(el.productId).val(),
                price: $(el.inputPrice).val(),
            };
            $("body").addClass("mi-loading");

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
                success: function () {
                    $("body").removeClass("mi-loading");
                },
                error: (err) => {
                    console.error(err);
                    $("body").removeClass("mi-loading");
                },
            });
        });
    };

    init();
};

try {
    changePrice();
} catch (error) {
    console.error("changePrice: ", changePrice);
}
